// Styles
import styles from './TablePaginationPerPageButton.module.css';

/**
 * TablePaginationPerPageButton component
 * @param {object} props - Component props
 * @param {string|number} props.value - Button value
 * @param {boolean} props.isActive - Whether the button is active/selected
 * @param {Function} props.onClick - Click handler
 * @param {React.ReactNode} props.children - Button content
 * @returns {JSX.Element} The TablePaginationPerPageButton component
 */
function TablePaginationPerPageButton({
  value,
  isActive = false,
  onClick,
  children,
}) {
  const handleClick = () => {
    if (onClick) {
      onClick(value);
    }
  };

  return (
    <button
      type="button"
      className={`${styles['table-pagination-per-page-button']} ${
        isActive ? styles['table-pagination-per-page-button-active'] : ''
      }`}
      onClick={handleClick}
      value={value}
    >
      {children}
    </button>
  );
}

export default TablePaginationPerPageButton;
